import { useEffect } from 'react';
import { Box, Button, Grid, Paper, Stack, Typography } from '@mui/material';
import { withTranslation } from 'react-i18next';
import { ImagePaths } from '../../../Utility/ImagePaths'
import { CheckAccessFunc } from '../../../Components/CommonFunctions/CommonFunctions'
import { Colors } from '../../../Styles/Colors'
import { localGetItem } from "../../../Utility/Services/CacheProviderService";
import './labconfig.css'

let userData = null;

const LabSettingHome = (props) => {

    useEffect(() => {
        userData = JSON.parse(localGetItem("loggedInUserInfo"))
    }, []);

    const settingsList = [
        {
            title: 'Lab Masters', icon: ImagePaths.opConfig.default, Access: CheckAccessFunc("Laboratory", "Settings", "Lab Masters", null, "Tab"),
            reports: [
                { master_names: 'Department Master', path: '/labSettings/LabMaster/DepartmentMaster' },
                { master_names: 'Container Master', path: '/labSettings/LabMaster/ContainerMaster' },
                { master_names: 'Specimen Master', path: "/labSettings/LabMaster/SpecimenMaster" },
                { master_names: 'Method Master', path: "/labSettings/LabMaster/MethodMaster" },
                { master_names: 'Antibiotic Master', path: "/labSettings/LabMaster/AntibioticMaster" },
                { master_names: 'Organism Master', path: "/labSettings/LabMaster/OrganismMaster" },
                { master_names: 'Organism Vs Antibiotic Name', path: "/labSettings/LabMaster/OrganismVsAntibioticName" },
                { master_names: 'Analyser Master', path: "/labSettings/LabMaster/AnalyserMaster" },
            ]
        },
        {
            title: 'Lab Configuration', icon: ImagePaths.corporateConfig.default, Access: CheckAccessFunc("Laboratory", "Settings", "Lab Configuration", null, "Tab"),
            reports: [
                { master_names: 'Result Configuration', path: '/labSettings/LabMaster/ResultConfiguration' },
                { master_names: 'Consumable Mapping', path: '/labSettings/LabMaster/ConsumableMapping' },
                // { master_names: 'Patient Demographics', path: '/labSettings/LabMaster/PatientDemographics' },
                { master_names: 'Referred Doctor', path: '/labSettings/LabMaster/ReferredDoctor' },
                { master_names: 'Outsource Configuration', path: '/labSettings/LabMaster/OutsourceConfiguration' },
                { master_names: 'Outsource Mapping', path: '/labSettings/LabMaster/OutsourceMapping' },
                { master_names: 'Lab E-Signature Configuration', path: '/labSettings/LabMaster/LabE-SignatureConfiguration' },
                { master_names: 'Print Configuration', path: '/labSettings/LabMaster/PrintConfiguration' }
            ]
        }
    ];

    const renderSettingsItem = (item) => {
        return (
            <Box component={'div'} className='eMed_rts_card'>
                <Paper className='eMed_rts_content'>
                    <Grid container className='eMed_rts_content_top'>
                        <Grid item xs={12} className='eMed_rts_txt_one'>
                            <Stack display={'flex'} flexDirection='row'>
                                <img src={item.icon} alt="" className='eMed_rts_icon' />
                                <Typography fontWeight={'600'}>{item.title}</Typography>
                            </Stack>
                        </Grid>
                        <Grid item xs={12} className='eMed_rts_content_btm'>
                            {item?.reports?.map((list, index) => {
                                return <Box display={'flex'} flexDirection={'row'} alignItems={'center'}>
                                    <Typography display={index === 0 ? "none" : 'inline'} color={Colors.themeDark}>|</Typography>
                                    <Button key={index} className='eMed_reports_text_btn'
                                        onClick={() => {
                                            props.history.push({ pathname: list.path })
                                        }}>{list.master_names}</Button>
                                </Box>
                            })}
                        </Grid>
                    </Grid>
                </Paper>
            </Box>
        )
    }

    return (
        <Box component={'div'} className='eMed_rts_home_container' overflow={'scroll'}>
            <Box>
                {settingsList.map((item, index) => {
                    if (CheckAccessFunc("Laboratory", "Reports", item.title, null, "Tab").viewAccess) {
                        return (<Stack key={`${item.title}_${index}`}>{renderSettingsItem(item)}</Stack>)
                    }
                })}
            </Box>
        </Box>
    )
}

export default withTranslation()(LabSettingHome);